import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { authApi } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import type { AuthUser } from '../../types';
import './Auth.css';


function OAuthCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser } = useAuth();
  const called = useRef(false);

  useEffect(() => {
    const status = searchParams.get('oauth');
    const error = searchParams.get('error');

    if (error) {
      if (!called.current) {
        called.current = true;
        navigate('/login?error=oauth_failed', { replace: true });
      }
      return;
    }

    if (status === 'success') {
      if (called.current) return;
      called.current = true;

      authApi.getMe()
        .then((data) => {
          localStorage.setItem('user', JSON.stringify(data));
          setUser(data);
          toast.success(t('auth.loginSuccess'));
          navigate('/', { replace: true });
        })
        .catch(() => {
          navigate('/login?error=oauth_failed', { replace: true });
        });
    }
  }, [searchParams, navigate, t, setUser]);


  return (
    <main className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <img src="/logo.png" alt="FCS" className="auth-logo" />
        <div className="oauth-loading">
          <span className="auth-spinner auth-spinner-brand"></span>
          <p>{t('auth.signingIn')}</p>
        </div>
      </div>
    </main>
  );
}

export default OAuthCallback;
